import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {  headers,SEND_CREDENTIALS_TO_EXHIBITOR_ACTION_TYPE,GET_EXHIBITOR_CREDENTIALS_LIST_ACTION_TYPE,getExhSendCredsLogUrl,createExhSendCredsLogUrl } from "../../utils/constants";

export const getExhSendCredLog_action = () => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        };
        const res = await axiosGet(getExhSendCredsLogUrl, params, headers);
        dispatch({
            type: GET_EXHIBITOR_CREDENTIALS_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createExhSendCredLog_action = (ExhRegistrationID) => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID:ExhRegistrationID,
            TriggeredBy:loginData.UserID
        };
        const res = await axiosPost(createExhSendCredsLogUrl, params, headers);
        dispatch({
            type: SEND_CREDENTIALS_TO_EXHIBITOR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
